export default "__VITE_ASSET__DJ01rvJF__"